module.exports = __webpack_public_path__ + "static/media/dungeon_floor_n.b37f400c.png";